import React from 'react';
import NavBar from '../components/NavBar';
import GameCard from '../components/GameCard';
import './Games.css'; // Assuming the CSS can be reused or will be adapted
import { Helmet } from 'react-helmet-async';

function CardGames() {
  const games = [
    {
      id: 'solitaireprocollection',
      title: 'Solitaire Pro Collection',
      description: 'A collection of classic solitaire card games including Klondike, FreeCell, Spider, TriPeaks, Pyramid, and Golf.',
      imageUrl: '/solitaireprocollection/assets/assets/card_logo.png',
      link: '/play/solitaireprocollection',
      infoLink: '/games/solitaire-pro-collection'
    },
    {
      id: 'euchre',
      title: 'Euchre',
      description: 'Play the classic trick-taking card game Euchre! Form partnerships, call trump, and outsmart your opponents in this fast-paced four-player card game.',
      imageUrl: '/euchre/assets/assets/card_logo.png',
      link: '/play/euchre',
      infoLink: '/games/euchre'
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Card Games - Solitaire Pro Collection & More</title>
        <meta name="description" content="Enjoy classic card games online! Play our Solitaire Pro Collection (Klondike, FreeCell, Spider, TriPeaks, Pyramid, and Golf). Free to play!" />
        <link rel="canonical" href="https://logicpuzzles.ca/card-games" />
        <meta property="og:title" content="Card Games - Solitaire Pro Collection & More" />
        <meta property="og:description" content="Enjoy classic card games online! Play Solitaire Pro Collection with Klondike, FreeCell, Spider, and more." />
        <meta property="og:url" content="https://logicpuzzles.ca/card-games" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://logicpuzzles.ca/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Card Games - Solitaire Pro Collection & More" />
        <meta name="twitter:description" content="Enjoy classic card games online! Play Solitaire Pro Collection with Klondike, FreeCell, Spider, and more." />
        <meta name="twitter:image" content="https://logicpuzzles.ca/og-image.png" />
      </Helmet>
      <NavBar />
      <div className="games-page">
        <div className="container">
          <p className="eyebrow">Card games</p>
          <h1>Our Card Games</h1>
          <p className="games-intro">
            Check out our selection of card games. Fun for solo play or with friends!
          </p>
          {games.length > 0 ? (
            <div className="games-grid">
              {games.map((game, i) => (
                <GameCard
                  key={game.id}
                  title={game.title}
                  description={game.description}
                  imageUrl={game.imageUrl}
                  link={game.link}
                  infoLink={game.infoLink}
                  loading={i < 6 ? 'eager' : 'lazy'}
                />
              ))}
            </div>
          ) : (
            <p>No card games available at the moment. Please check back soon!</p>
          )}
          <section className="games-details">
            <h2>Classic Card Strategy, Polished for the Web</h2>
            <p>
              Solitaire Pro Collection brings together timeless card games with smooth controls and clear layouts.
              Whether you prefer quick rounds or deeper strategy, the collection offers a clean, focused experience.
            </p>
            <div className="games-details-grid">
              <div>
                <h3>Multiple Variants</h3>
                <p>Play Klondike, FreeCell, Spider, TriPeaks, Pyramid, and Golf in one place.</p>
              </div>
              <div>
                <h3>Undo & Hints</h3>
                <p>Take your time, experiment with strategies, and learn advanced moves.</p>
              </div>
              <div>
                <h3>Cross-Device Friendly</h3>
                <p>Optimized for both mouse and touch controls with responsive layouts.</p>
              </div>
            </div>
          </section>
          <section className="games-faq">
            <h2>Card Games FAQ</h2>
            <div className="games-faq-grid">
              <div>
                <h3>Is Solitaire Pro Collection free?</h3>
                <p>Yes. You can play for free on the web and enjoy full classic solitaire rules.</p>
              </div>
              <div>
                <h3>Which variant is best for beginners?</h3>
                <p>Klondike is the most familiar starting point, while TriPeaks is great for quick rounds.</p>
              </div>
              <div>
                <h3>Does it work on mobile?</h3>
                <p>Yes. The game is optimized for touch controls and smaller screens.</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default CardGames; 